import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "14.3 32 0 32 0 0 32 0 32 14.3 29.5 14.3 29.5 2.5 2.5 2.5 2.5 29.5 14.3 29.5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -1.3,
			y: 23.1,
			transform: "rotate(-45.001 7.71 24.33)",
			className: "icon-fill-primary",
			width: 18.1,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -2.4,
			y: 9.7,
			transform: "rotate(-45.001 10.9 10.9)",
			className: "icon-fill-primary",
			width: 26.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -.7,
			y: 4.6,
			transform: "rotate(-44.968 5.855 5.86)",
			className: "icon-fill-primary",
			width: 13.1,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.4 26.9l4.9-2.9-1.3-2.2-4.7 2.8-2-2.1-1.1-8.3-2.5.3 1 7.3-6.9-1.6v-5.9h-2.5v5.4l-5.8 3.6-3.9-1.9-1.1 2.2 4.4 2.2 5.5 4.8-3.7 4.4h-5.4v2.5h4.8v6.2h2.5v-7l3.8-4.5 6.6 5.7-2.3 5.3 2.3 1 2.3-5.4h3.9l5.3 1.2.6-2.4-4.6-1.1v-9.6zm-15.1 1.2L20.7 25l3.6-2.2v5.3zm2.5 2.1v-7.5l8.2 1.9 1.9 2v9.7h-3l-7.1-6.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M20.7 13L31.2 2.4 29.4.6 17.1 13H13v32h32V13H20.7zm21.8 29.5h-27v-27h27v27z"
		})
	]
});
export default SvgIcon;
